import { type Form } from '@wix/ambassador-forms-v4-form/types';
import { applyOverrides as applyRuleOverrides } from '@wix/form-conditions';
import { applyNestedFormOverrides } from '@wix/nested-form-overrides';

import { applyNestedForms } from '../../services';
import { applyFormOverrides } from '../../services/form-overrides';
import type { FormOverrides, FormValues } from '../../types';

export function applyAllOverrides(
  form: Form,
  values: FormValues,
  overrides: FormOverrides | undefined,
) {
  return applyNestedForms(
    applyFormOverrides(
      applyNestedFormOverrides(applyRuleOverrides(form, values)),
      overrides ?? {},
    ),
  );
}
